// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Fahrzeug } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetFahrzeug(): (fahrzeugId: string) => Promise<Fahrzeug> {
  const getAPI = useGetApi();
  return useCallback(
    async (fahrzeugId) =>
      (await getAPI()).fahrzeuge.getFahrzeug({ fahrzeugId }),
    [getAPI]
  );
}
